import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import DBNDomainComponent from '../components/dbn-domain.component';
import { deepCopy } from '../../../../../../common/services/common.service';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { tenantOpenNetworkDomains } from '../../../../../../redux/dbn-cloud/tenant-open-network-domains/action';
import { selectOpennetworkDomainCreatedItem, selectOpennetworkDomainUpdatedItem, selectTenantOpennetworkDomainsListItems } from '../../../../../../redux/dbn-cloud/tenant-open-network-domains/selector';
import { selectOpennetworkDomainQueryItems } from '../../../../../../redux/opennetwork-domains/selector';

let currentChange: any = {}

const DBNDomain = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const { getUploadFiles } = useAppSelector(selectCurrent)

    const [categoryImageIndex, setCategoryImageIndex] = useState<any>([])
    const [mediaFiles, setMediaFiles] = useState<any>([])
    const [openFile, setOpenFile] = useState<any>([]);
  
    const listDBNDomainsData = useSelector(selectTenantOpennetworkDomainsListItems)
    const queryDBNDomainData = useSelector(selectOpennetworkDomainQueryItems)
    const createDBNDomainData = useSelector(selectOpennetworkDomainCreatedItem)
    const updateDBNDomainData = useSelector(selectOpennetworkDomainUpdatedItem)
    const [selectedDBNDomain, setSelectedDBNDomain] = useState<any>({
        Name: '',
        IsSubDomain: false,
        ParentDomainId: 0,
        Code: ''
    })

    const listDBNDomains = () => {
        dispatch(tenantOpenNetworkDomains.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
            entity: 'tenantOpenNetworkDomains',
            jsonData: {}
        }))
    }

    const queryDBNDomain = (id: Number) => {
        dispatch(tenantOpenNetworkDomains.query({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch-detail`,
            entity: 'tenantOpenNetworkDomains',
            jsonData: {
                Records: [
                    {
                        Id: id
                    }
                ]
            }
        }))
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        console.log('event: any, field', selectedDBNDomain, event, field)
        setSelectedDBNDomain({ ...selectedDBNDomain, [field]: event })
    }

    
    const handleFormItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(mediaFiles);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setMediaFiles(items);
      }
    
  

    useEffect(() => {
        console.log('queryDBNDomainData?.result?.items', queryDBNDomainData?.result?.items)
        if (queryDBNDomainData?.result?.items) {
            setSelectedDBNDomain(queryDBNDomainData?.result?.items)
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryDBNDomainData?.result?.items?.MediaMappings?.MediaFiles || mediaFiles });
            setMediaFiles(localSelectedMedia)
      
        }
    }, [queryDBNDomainData])

    useEffect(() => {
        listDBNDomains()
        setSelectedDBNDomain({
            Name: '',
            IsSubDomain: false,
            ParentDomainId: 0,
            Code: ''
        })
        if (parmas?.id > 0) {
            queryDBNDomain(Number(parmas?.id))
        } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)  
  
        }
    }, [parmas])

    useEffect(() => {
        console.log('selectedDBNDomain', selectedDBNDomain)
    }, [selectedDBNDomain]);

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        mediaFiles.splice(
            mediaFiles.length - 1,
            1
          )
      
          const localMediaFiles = _.map(mediaFiles, (item) => {
            return {
              ...item,
              OwnerId: Number(parmas?.id) || 0,
              Name: selectedDBNDomain?.Name,
              Description: selectedDBNDomain?.Name,
              IsApproved: true,
            }
          })

        if (parmas?.id > 0) {
            await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'update' }))
            await dispatch(tenantOpenNetworkDomains.update({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Context: {},
                    Records: [
                        {
                            ...selectedDBNDomain,
                            Id: parmas?.id,
                            MediaMappings: { MediaFiles: localMediaFiles, Templates: selectedDBNDomain?.MediaMappings?.Templates || [] },
                        }
                    ]
                }
            }))
            back();
        } else {
            await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'create' }))
            await dispatch(tenantOpenNetworkDomains.create({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Records: [
                        {
                            ...selectedDBNDomain,
                            Id: 0,
                            MediaMappings: { MediaFiles: localMediaFiles, Templates: selectedDBNDomain?.MediaMappings?.Templates || [] },
                        }
                    ]
                }
            }))
            back();
        }
    }

    // useEffect(() => {
    //     console.log('listDBNDomainsData', listDBNDomainsData)
    // }, [listDBNDomainsData]);

    const back = () => {
        navigate(-1)
    }
    
    const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
        const localSelectedmedia = deepCopy(selectedMediaFilesArg)
        const newsSelectedMedia = {
          Id: 0,
          FileTypeId: 0,
          OwnerTypeId: 1008,
          FileMappingURL: ''
        }
        if (localSelectedmedia.length === 0 ||
          localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
        ) {
          localSelectedmedia?.push(newsSelectedMedia)
        }
        return localSelectedmedia
      }
    
      const setCombinationInfo = async () => {
        let localSelectedMedia = deepCopy(mediaFiles)
        localSelectedMedia.splice(
          currentChange.idx,
          1,
          { ...localSelectedMedia[currentChange.idx] }
        );
        localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
        currentChange.field = 'FileTypeIdDONE'
        setMediaFiles(localSelectedMedia)
      }
    
      const changeImage = (idx: number, templateField: any, fileType: any) => {
        setCategoryImageIndex(idx)
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenFile({
          currentFileSrc: mediaFiles[idx][templateField],
          folder: 'Category',
          type: fileType
        })
      }
    
      
      const handleSubmit = (data: any) => {
        mediaFiles[categoryImageIndex].FileMappingURL = data
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    
      const handleClose = () => {
        dispatch(settings.set({ getUploadFiles: 'close' }))
      }
    
      useEffect(() => {
        if (currentChange.field === 'FileTypeId') {
          setCombinationInfo()
        }
      }, [mediaFiles])

    return (
        <>
        {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
            folder={openFile?.folder}
            handleClose={handleClose}
            handleFilesSubmit={handleSubmit}
            type={openFile?.type}
            ownerId={parmas?.id}
          />}
            {listDBNDomainsData?.isLoading ||
                queryDBNDomainData?.isLoading ||
                createDBNDomainData?.isLoading ||
                updateDBNDomainData?.isLoading ? <PageLoader /> :
                selectedDBNDomain && <DBNDomainComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedDBNDomain={selectedDBNDomain}
                    domains={listDBNDomainsData?.result?.items}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    handleFormItemChange={handleFormItemChange}
                    mediaFiles={mediaFiles}
                    changeImage={changeImage}
                />
            }
        </>
    )
}

export default DBNDomain;